/**
 * iCarsoft Tool Finder — 逐级展开三步选购器(2026-07 交互重构)
 * 交互:STEP 01 车型下拉 → 选完才显示 STEP 02(类型/等级)→ 再显示 STEP 03(等级/品牌);
 *      回改前面的选择自动重置后面的步骤;路径走完才显示结果卡片。
 * 数据:section 内 Liquid 渲染的实时产品 JSON(价格随市场/挂价实时变动)。
 * 加购:复用主题 Enterprise cart 流程;套装卡一次加购两件(JSON items)。
 *
 * 决策树:
 *   Passenger Car → Multi-brand → Professional/Semi Professional/Essential → 产品
 *                 → Single-brand → 品牌(搜索) → 品牌阶梯(V4.0 最前)
 *   Motorcycle   → Multi-brand → MT Pro/MT Pro Mini/MT V6+
 *                 → Single-brand → 品牌(搜索) → MT V6 专用 + 多品牌兜底
 *   Heavy Duty   → Semi(HD V4.0)/Professional(CR Unicorn S、Ultra P+HD6000、Ultra+HD2000)/Essential(HD V3.0)
 *   Marine       → 直接出结果(MarineScan X9)
 */
(() => {
  if (customElements.get('icarsoft-tool-finder')) return;

  /* ---------- 产品 handle ---------- */
  const P = {
    ultraP: 'cr-ultra-p',
    ultra: 'cr-ultra',
    eagleP: 'cr-eagle-p',
    eagle: 'icarsoft-cr-eagle',
    legend: 'cr-legend',
    unicorn: 'cr-unicorn',
    unicornS: 'icarsoft-cr-unicorn-for-passenger-cars',
    maxP: 'icarsoft-cr-max-p',
    maxBTe: 'icarsoft-cr-max-bt-enhanced-wireless-bidirectional-diagnostic-tool',
    maxBT: 'cr-max-bt',
    max: 'cr-max',
    proS: 'icarsoft-cr-pro-s',
    proPlus: 'icarsoft-cr-pro',
    eliteP: 'icarsoft-cr-elite-p',
    i800: 'i800',
    i820: 'i820',
    e660: 'icarsoft-e660',
    i620: 'i620',
    i610: 'i610',
    hd40: 'icarsoft-hd-v4-0-multi-system-heavy-duty-vehicles-diagnostic-tool',
    hd30: 'hd-v3-0',
    hd2000: 'hd2000-heavy-duty-truck-package',
    mtPro: 'professional-multi-systems-motorcycle-diagnostic-tool-mt-pro',
    mtMini: 'mt-pro-mini',
    mtV6p: 'mt-v6-plus',
    x9: 'marinescan-x9'
  };

  /* ---------- 套装卡(合并一张卡:合计价,一次加购两件) ---------- */
  const COMBOS = {
    'combo-ultrap-hd6000': {
      main: P.ultraP, kit: 'hd6000', name: 'CR Ultra P + HD6000',
      tag: 'OE-level tablet + HD6000 heavy-duty kit'
    },
    'combo-ultra-hd2000': {
      main: P.ultra, kit: P.hd2000, name: 'CR Ultra + HD2000',
      tag: 'Pro scanner + HD2000 heavy-duty truck kit'
    }
  };

  /* ---------- 营销短语(卡片副标题);缺省回退产品标题 ---------- */
  const TAGS = {
    [P.ultraP]: 'ECU coding · CAN FD · DoIP · topology map',
    [P.ultra]: 'Advanced scanner · Bluetooth VCI',
    [P.eagleP]: '2026 flagship tablet · CAN FD · DoIP',
    [P.eagle]: 'Professional bi-directional tablet',
    [P.legend]: 'CAN FD & DoIP protocol support',
    [P.unicorn]: 'OE-level · cars, coaches & buses',
    [P.unicornS]: 'OE-level · cars & commercial trucks',
    [P.maxP]: 'Bi-directional · 58 brands · lifetime updates',
    [P.maxBTe]: 'Wireless bi-directional · enhanced VCI',
    [P.maxBT]: 'Bluetooth wireless · all systems',
    [P.max]: 'All systems · best-reviewed',
    [P.proS]: 'Bi-directional · all systems',
    [P.proPlus]: 'All systems · fan favorite',
    [P.eliteP]: 'Touchscreen & WiFi · multi-system',
    [P.i800]: 'Full OBD2 + battery test · best value',
    [P.i820]: 'OBD2 / EOBD / CAN · budget pick',
    [P.e660]: '4 systems · engine / ABS / SRS / AT',
    [P.i620]: 'Bluetooth OBD2 engine scan',
    [P.i610]: 'WiFi OBD2 engine scan',
    [P.hd40]: 'Multi-system heavy-duty · newest platform',
    [P.hd30]: 'Heavy-duty code reader · budget pick',
    [P.hd2000]: 'Complete heavy-duty workshop bundle',
    [P.mtPro]: 'Pro multi-system · most motorcycle brands',
    [P.mtMini]: 'Compact multi-system · most motorcycles',
    [P.mtV6p]: 'Most motorcycles · essential systems',
    [P.x9]: 'Marine engine diagnostics · new arrival',
    'icarsoft-por-v4-0': 'Newest Porsche series · touchscreen & wifi',
    'por-ii-1': 'Porsche · price-drop deal',
    'por-v3-0': 'Porsche all-systems',
    'por-v2-0': 'Porsche all-systems',
    'p700-v2-0': 'Porsche diagnostics',
    'por-v1-0': 'Porsche / Cayenne entry pick',
    'icarsoft-mb-v4-0': 'MB / Sprinter / Smart / Maybach',
    'mb-v3-0-enhanced-edition': 'MB V3.0 + 38-pin adapter for older Benz',
    'mb-v3-0': 'MB / Sprinter / Smart',
    'mb-ii': 'MB / Sprinter / Smart',
    'mb-v2-0': 'MB / Sprinter / Smart',
    i980: 'Mercedes entry diagnostics',
    'icarsoft-bmm-v4-0': 'BMW / Mini / Rolls-Royce · newest series',
    'bmw-v3-0': 'BMW / Mini / Rolls-Royce',
    'bmm-v2-0': 'BMW / Mini',
    'bmm-v1-0': 'BMW / Mini · live data entry pick',
    'icarsoft-lr-v4-0': 'Land Rover / Jaguar · newest series',
    'lr-v3-0': 'Land Rover / Jaguar all-systems',
    'lr-v2-0': 'Land Rover / Jaguar · ABS service',
    'lr-v1-0': 'Land Rover / Jaguar · SAS reset',
    'icarsoft-vaws-v4-0': 'VW / Audi / Škoda / Seat / Bentley',
    'icarsoft-de-v4-0': 'All German makes · touchscreen & wifi',
    'vaws-v3-0': 'VW / Audi / Škoda',
    'vaws-v2-0': 'VW / Audi / Škoda / Seat',
    'vaws-v1-0': 'VW / Audi / Škoda entry pick',
    'icarsoft-vol-v4-0': 'Volvo / Saab · newest series',
    'vol-v3-0': 'Volvo / Saab all-systems',
    'vol-v2-0': 'Volvo / Saab',
    i906: 'Volvo / Saab · new arrival',
    'vol-v1-0': 'Volvo / Saab entry pick',
    'icarsoft-op-v4-0': 'Opel / Vauxhall · newest series',
    'op-v3-0': 'Opel / Vauxhall · Auto-VIN',
    'op-v2-0': 'Opel / Vauxhall',
    'op-v1-0': 'Opel / Vauxhall entry pick',
    'icarsoft-us-v4-0': 'American makes · Ford / GM / Chrysler / Jeep',
    'us-v3-0': 'Ford / GM / Chrysler / Jeep',
    'us-v2-0': 'Ford / GM / Chrysler (Jeep / Dodge)',
    'fd-v1-0': 'Ford / Holden entry pick',
    i900: 'GM entry diagnostics',
    'icarsoft-jp-v4-0': 'Japanese & Korean makes · newest series',
    'jp-v3-0': 'Nissan / Toyota / Honda / Hyundai / Kia…',
    'jp-v2-0': 'Toyota / Lexus / Isuzu / Nissan / Honda…',
    'tyt-v1-0': 'Toyota / Lexus / Scion / Isuzu entry pick',
    'icarsoft-fr-v4-0': 'French & Italian makes · newest series',
    'fr-v3-0': 'Citroën / Peugeot / Renault / Fiat / Alfa',
    'fr-v2-0': 'Citroën / Peugeot / Renault / Fiat / Alfa',
    'cp-v1-0': 'Peugeot / Citroën · oil reset entry pick'
  };

  /* ---------- 单品牌产品阶梯(专用系列 新→旧;2026-07 逐产品调研) ---------- */
  const SINGLE_BRAND = {
    Porsche: ['icarsoft-por-v4-0', 'por-v3-0', 'por-v2-0', 'p700-v2-0', 'por-v1-0', 'por-ii-1'],
    'Mercedes-Benz': ['icarsoft-mb-v4-0', 'mb-v3-0-enhanced-edition', 'mb-v3-0', 'mb-ii', 'mb-v2-0', 'i980'],
    Sprinter: ['icarsoft-mb-v4-0', 'mb-v3-0-enhanced-edition', 'mb-v3-0', 'mb-ii', 'mb-v2-0'],
    Smart: ['icarsoft-mb-v4-0', 'mb-v3-0-enhanced-edition', 'mb-v3-0', 'mb-ii', 'mb-v2-0'],
    Maybach: ['icarsoft-mb-v4-0'],
    BMW: ['icarsoft-bmm-v4-0', 'bmw-v3-0', 'bmm-v2-0', 'bmm-v1-0', 'icarsoft-de-v4-0'],
    Mini: ['icarsoft-bmm-v4-0', 'bmw-v3-0', 'bmm-v2-0', 'bmm-v1-0'],
    'Rolls-Royce': ['icarsoft-bmm-v4-0', 'bmw-v3-0'],
    'Land Rover': ['icarsoft-lr-v4-0', 'lr-v3-0', 'lr-v2-0', 'lr-v1-0'],
    Jaguar: ['icarsoft-lr-v4-0', 'lr-v3-0', 'lr-v2-0', 'lr-v1-0'],
    Volkswagen: ['icarsoft-vaws-v4-0', 'vaws-v3-0', 'vaws-v2-0', 'vaws-v1-0', 'icarsoft-de-v4-0'],
    Audi: ['icarsoft-vaws-v4-0', 'vaws-v3-0', 'vaws-v2-0', 'vaws-v1-0', 'icarsoft-de-v4-0'],
    'Škoda': ['icarsoft-vaws-v4-0', 'vaws-v3-0', 'vaws-v2-0', 'vaws-v1-0'],
    Seat: ['icarsoft-vaws-v4-0', 'vaws-v2-0'],
    Bentley: ['icarsoft-vaws-v4-0'],
    Volvo: ['icarsoft-vol-v4-0', 'vol-v3-0', 'vol-v2-0', 'i906', 'vol-v1-0'],
    Saab: ['icarsoft-vol-v4-0', 'vol-v3-0', 'vol-v2-0', 'i906', 'vol-v1-0'],
    Opel: ['icarsoft-op-v4-0', 'op-v3-0', 'op-v2-0', 'op-v1-0', 'icarsoft-de-v4-0'],
    Vauxhall: ['icarsoft-op-v4-0', 'op-v3-0', 'op-v2-0', 'op-v1-0'],
    Ford: ['icarsoft-us-v4-0', 'us-v3-0', 'us-v2-0', 'fd-v1-0'],
    Holden: ['fd-v1-0'],
    GM: ['icarsoft-us-v4-0', 'us-v3-0', 'us-v2-0', 'i900'],
    Chevrolet: ['icarsoft-us-v4-0', 'us-v3-0', 'us-v2-0', 'i900'],
    Chrysler: ['us-v3-0', 'us-v2-0'],
    Jeep: ['icarsoft-us-v4-0', 'us-v3-0', 'us-v2-0'],
    Dodge: ['icarsoft-us-v4-0', 'us-v2-0'],
    Toyota: ['icarsoft-jp-v4-0', 'jp-v3-0', 'jp-v2-0', 'tyt-v1-0'],
    Lexus: ['icarsoft-jp-v4-0', 'jp-v2-0', 'tyt-v1-0'],
    Scion: ['icarsoft-jp-v4-0', 'tyt-v1-0'],
    Isuzu: ['icarsoft-jp-v4-0', 'jp-v2-0', 'tyt-v1-0'],
    Nissan: ['icarsoft-jp-v4-0', 'jp-v3-0', 'jp-v2-0'],
    Infiniti: ['icarsoft-jp-v4-0'],
    Honda: ['icarsoft-jp-v4-0', 'jp-v3-0', 'jp-v2-0'],
    Acura: ['icarsoft-jp-v4-0'],
    Subaru: ['icarsoft-jp-v4-0', 'jp-v3-0', 'jp-v2-0'],
    Mazda: ['icarsoft-jp-v4-0'],
    Mitsubishi: ['icarsoft-jp-v4-0'],
    Suzuki: ['icarsoft-jp-v4-0', 'jp-v3-0'],
    Kia: ['icarsoft-jp-v4-0', 'jp-v3-0', 'jp-v2-0'],
    Hyundai: ['icarsoft-jp-v4-0', 'jp-v3-0', 'jp-v2-0'],
    Peugeot: ['icarsoft-fr-v4-0', 'fr-v3-0', 'fr-v2-0', 'cp-v1-0'],
    'Citroën': ['icarsoft-fr-v4-0', 'fr-v3-0', 'fr-v2-0', 'cp-v1-0'],
    Renault: ['icarsoft-fr-v4-0', 'fr-v3-0', 'fr-v2-0'],
    Dacia: ['icarsoft-fr-v4-0'],
    Fiat: ['fr-v3-0', 'fr-v2-0'],
    'Alfa Romeo': ['fr-v3-0', 'fr-v2-0']
  };

  /* ---------- 品牌列表 ---------- */
  // 核心 58 品牌(CR 多品牌系列覆盖;子品牌独立成项)
  const CORE_MAKES = [
    'Porsche', 'Mercedes-Benz', 'Sprinter', 'Smart', 'Maybach',
    'BMW', 'Mini', 'Rolls-Royce',
    'Land Rover', 'Jaguar',
    'Volkswagen', 'VW CV', 'VW LT3', 'Audi', 'Škoda', 'Seat', 'Bentley', 'Bugatti', 'Lamborghini',
    'Volvo', 'Saab', 'Opel', 'Vauxhall',
    'Ford', 'Holden', 'GM', 'Chevrolet', 'Daewoo', 'Chrysler', 'Jeep', 'Dodge',
    'Toyota', 'Lexus', 'Scion', 'Isuzu', 'Nissan', 'Nissan GTR', 'Infiniti',
    'Honda', 'Acura', 'Subaru', 'Mazda', 'Mitsubishi', 'Suzuki', 'Kia', 'Hyundai',
    'Renault', 'Renault-Samsung', 'Dacia',
    'Peugeot', 'Citroën', 'DS',
    'Fiat', 'Abarth', 'Alfa Romeo', 'Lancia', 'Ferrari', 'Maserati',
    'Man LD'
  ];
  // 扩展品牌:仅 CR Legend 支持(2026-07 依据 5 个旗舰产品页 REGIONS 数据调研)
  const EXTENDED_MAKES = [
    'Aston Martin', 'Buick', 'Cadillac', 'Lincoln', 'Rover', 'Daihatsu', 'SsangYong',
    'Proton', 'Perodua', 'Tata', 'Mahindra', 'Maruti', 'IVECO', 'Luxgen', 'Qoros',
    'Maxus', 'SAIC MG', 'SGM', 'JMC', 'Foton', 'Great Wall', 'Brilliance', 'BAIC',
    'Changan', 'Changhe', 'Chery', 'Hafei', 'King Long', 'Joylong', 'Lifan',
    'Trumpchi', 'GAZ', 'UAZ', 'PAZ', 'IZH', 'SEAZ', 'IKCO', 'MVM', 'CMC',
    'Flyer', 'Jacty', 'Jiao', 'Liuwel-TY', 'Spark', 'Weili', 'Xial', 'Zhongshun'
  ];
  const EXTENDED_SET = new Set(EXTENDED_MAKES);
  const CAR_MAKES = CORE_MAKES.concat(EXTENDED_MAKES).concat(['Other make']);

  const MOTO_MAKES = [
    'Harley-Davidson', 'Honda', 'Yamaha', 'BMW', 'Suzuki', 'Kawasaki', 'Ducati', 'KTM',
    'Triumph', 'Indian', 'Vespa', 'Piaggio', 'Aprilia', 'Moto Guzzi', 'Polaris', 'Victory',
    'Enfield', 'Benelli', 'QJBenelli', 'CFMOTO', 'Kymco', 'SYM', 'Hyosung', 'Bajaj', 'TVS',
    'Peugeot', 'Derbi', 'Gilera', 'Haojue', 'Hartford', 'HM', 'Aeon', 'PGO', 'Royal Alloy',
    'Shineray', 'Zontes', 'Other brand'
  ];

  // 摩托专用 MT V6 handle
  const MT_V6 = {
    'Harley-Davidson': 'icarsoft-mt-v6-for-harley-davidson',
    BMW: 'mtv6-bmw',
    Suzuki: 'icarsoft-motorcycle-diagnostic-tool-mt-v6-for-suzuki',
    Kawasaki: 'icarsoft-motorcycle-diagnostic-tool-mt-v6-for-kawasaki',
    Indian: 'icarsoft-motorcycle-diagnostic-tool-mt-v6-for-indian',
    Honda: 'mt-v6-for-honda',
    Yamaha: 'mt-v6-for-yamaha',
    Ducati: 'mt-v6-for-ducati',
    KTM: 'mt-v6-for-ktm',
    Triumph: 'mt-v6-for-triumph',
    Vespa: 'mt-v6-for-vespa',
    Piaggio: 'mt-v6-for-piaggio',
    Aprilia: 'mt-v6-for-aprilia',
    'Moto Guzzi': 'mt-v6-for-moto-guzzi',
    Polaris: 'mt-v6-for-polaris',
    Victory: 'mt-v6-for-victory',
    Enfield: 'mt-v6-for-enfield',
    Benelli: 'mt-v6-for-benelli',
    QJBenelli: 'mt-v6-for-qjbenelli',
    CFMOTO: 'mt-v6-for-cfmoto',
    Kymco: 'mt-v6-for-kymco',
    SYM: 'mt-v6-for-sym',
    Hyosung: 'mt-v6-for-hyosung',
    Bajaj: 'mt-v6-for-bajaj',
    TVS: 'mt-v6-for-tvs',
    Peugeot: 'mt-v6-for-peugeot',
    Derbi: 'mt-v6-for-derbi',
    Gilera: 'mt-v6-for-gilera',
    Haojue: 'mt-v6-for-haojue',
    Hartford: 'mt-v6-for-hartford',
    HM: 'mt-v6-for-hm',
    Aeon: 'mt-v6-for-aeon',
    PGO: 'mt-v6-for-pgo',
    'Royal Alloy': 'mt-v6-for-royal-alloy',
    Shineray: 'mt-v6-for-shineray',
    Zontes: 'mt-v6-for-zontes'
  };

  /* ---------- 决策树选项 ---------- */
  const VEHICLE_OPTS = [
    { key: 'car', label: 'Passenger Car', ico: '<path d="M5 13l1.5-4.5A2 2 0 018.4 7h7.2a2 2 0 011.9 1.5L19 13M5 13h14v4H5zM7 17v2M17 17v2"/><circle cx="8" cy="15" r=".6"/><circle cx="16" cy="15" r=".6"/>' },
    { key: 'moto', label: 'Motorcycle', ico: '<circle cx="6" cy="16" r="3"/><circle cx="18" cy="16" r="3"/><path d="M6 16l4-6h5l2 6M10 10l-1-2H7"/>' },
    { key: 'truck', label: 'Heavy Duty', ico: '<path d="M3 7h11v8H3zM14 10h4l3 3v2h-7zM3 15v2M7 17a1.5 1.5 0 103 0M17 17a1.5 1.5 0 103 0"/>' },
    { key: 'marine', label: 'Marine', ico: '<path d="M4 17c1.3 1.1 2.7 1.1 4 0s2.7-1.1 4 0 2.7 1.1 4 0 2.7-1.1 4 0M6 14l1.2-5H14l3 5M10 9V5h2.5v4"/>' }
  ];
  const TYPE_OPTS = [
    { key: 'multi', label: 'Multi-brand Diagnostic Tools' },
    { key: 'single', label: 'Single-brand Diagnostic Tools' }
  ];
  const GRADE_OPTS = [
    { key: 'semi', label: 'Semi Professional Diagnostic Tools' },
    { key: 'pro', label: 'Professional Diagnostic Tools' },
    { key: 'essential', label: 'Essential Diagnostic Tools' }
  ];

  /* ---------- 工具函数 ---------- */
  function shortName(title) {
    let t = title.replace(/^iCarsoft\s+/i, '').replace(/^\[[^\]]*\]\s*/, '');
    t = t.replace(/\s+Motorcycle Diagnostic Tool(?=\s+for\s)/i, '');
    if (/^MT V6 for /i.test(t)) return t;
    const cutMarkers = [
      ' — ', ' – ', ' - ', ' (', ' OE-Level', ' Advanced', ' Professional', ' 2026',
      ' Wireless', ' Bidirectional', ' Bi-Directional', ' NEW Version', ' WIFI', ' Bluetooth',
      ' TPMS Programming', ' TPMS Activation', ' Multi-System', ' Heavy Duty', ' OBDII',
      ' Motorcycle Diagnostic', ' Car Diagnostic', ' Automotive Diagnostic', ' Diagnostic',
      ' Porsche Diagnostic', ' Videoscope', ' Battery Test'
    ];
    let cut = t.length;
    cutMarkers.forEach((m) => {
      const idx = t.indexOf(m);
      if (idx > 0 && idx < cut) cut = idx;
    });
    t = t.slice(0, cut).trim();
    t = t.replace(/\s+for\s+.+$/i, '').replace(/\s+for$/i, '');
    return t || title;
  }

  // 按样例价格串的千分位/小数位格式,格式化分值(用于套装合计价)
  function moneyLike(sample, cents) {
    const m = String(sample).match(/([\d.,\s]+\d)/);
    if (!m) return sample;
    const num = m[1];
    const decMatch = num.match(/([.,])(\d{2})$/);
    const dec = decMatch ? decMatch[1] : null;
    const thou = dec === ',' ? '.' : ',';
    let intPart = String(Math.round(cents / 100 * 100) / 100).split('.')[0];
    const frac = String((cents % 100 + 100) % 100).padStart(2, '0');
    intPart = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    const out = dec ? intPart + dec + frac : intPart;
    return String(sample).replace(num, out);
  }

  class ICarsoftToolFinder extends HTMLElement {
    connectedCallback() {
      try {
        this.products = JSON.parse(this.querySelector('[data-ictf-products]').textContent);
      } catch (e) {
        this.products = {};
      }
      // 逐级状态:vehicle → two(类型/等级) → three(等级/品牌);open = 当前展开的下拉序号
      this.state = { vehicle: null, two: null, three: null, open: null };
      this.strings = {
        best: this.dataset.labelBest || 'BEST MATCH',
        also: this.dataset.labelAlso || 'ALSO FITS',
        buy: this.dataset.labelBuy || 'Buy',
        soldOut: this.dataset.labelSoldOut || 'Sold out',
        fitOne: this.dataset.labelFitOne || 'TOOL FITS YOUR SELECTION',
        fitMany: this.dataset.labelFitMany || 'TOOLS FIT YOUR SELECTION'
      };
      // 下拉开关
      this.querySelectorAll('[data-ictf-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const n = Number(btn.dataset.ictfToggle);
          this.setState({ open: this.state.open === n ? null : n });
        });
      });
      // 2026-07:下拉默认保持展开(点组件外不再收起),选完选项才收起;
      // 点击输入框本身仍可手动开合
      this.render();
    }

    setState(patch) {
      Object.assign(this.state, patch);
      this.render();
      // 自动展开下一步时,把该步骤滚进视野(移动端纵向堆叠时尤其需要)
      if (patch.open === 2 || patch.open === 3) {
        const el = this.querySelector(`[data-ictf-step="${patch.open}"]`);
        if (el && el.scrollIntoView) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 80);
      }
    }

    /* ---------- 每一步的配置(选项/标题/占位/是否带搜索) ---------- */
    stepConfig(n) {
      const S = this.state;
      if (n === 1) {
        return { opts: VEHICLE_OPTS, key: 'vehicle', title: null, ph: 'Please Select Your Vehicle Type', search: false };
      }
      if (n === 2) {
        if (S.vehicle === 'car' || S.vehicle === 'moto') {
          return { opts: TYPE_OPTS, key: 'two', title: 'STEP 02 — TYPE', ph: 'Please Select Tool Type', search: false };
        }
        if (S.vehicle === 'truck') {
          return { opts: GRADE_OPTS, key: 'two', title: 'STEP 02 — GRADE', ph: 'Please Select Tool Grade', search: false };
        }
        return null; // marine 无第二步
      }
      // n === 3
      if (S.vehicle === 'car' && S.two === 'multi') {
        return { opts: GRADE_OPTS, key: 'three', title: 'STEP 03 — GRADE', ph: 'Please Select Tool Grade', search: false };
      }
      if (S.vehicle === 'car' && S.two === 'single') {
        // 单车型品牌前加小号 "for"；"Other make" 不加
        const opts = CAR_MAKES.map((m) => ({ key: m, label: m === 'Other make' ? m : '<span class="ictf__for">for</span>' + m }));
        return { opts, key: 'three', title: 'STEP 03 — BRAND', ph: 'Please Select Vehicle Brand', search: true };
      }
      if (S.vehicle === 'moto' && S.two === 'single') {
        // 单车型品牌前加小号 "for"；"Other brand" 不加
        const opts = MOTO_MAKES.map((m) => ({ key: m, label: m === 'Other brand' ? m : '<span class="ictf__for">for</span>' + m }));
        return { opts, key: 'three', title: 'STEP 03 — BRAND', ph: 'Please Select Vehicle Brand', search: true };
      }
      return null;
    }

    // 路径是否已走完(可出结果)
    isComplete() {
      const S = this.state;
      if (!S.vehicle) return false;
      if (S.vehicle === 'marine') return true;
      if (S.vehicle === 'truck') return !!S.two;
      if (S.vehicle === 'moto') return S.two === 'multi' ? true : !!(S.two && S.three);
      // car
      return !!(S.two && S.three);
    }

    /* ---------- 匹配逻辑 ---------- */
    getMatches() {
      const S = this.state;
      let handles = [];
      if (S.vehicle === 'marine') {
        handles = [P.x9];
      } else if (S.vehicle === 'truck') {
        if (S.two === 'semi') handles = [P.hd40];
        else if (S.two === 'essential') handles = [P.hd30];
        else if (S.two === 'pro') handles = [P.unicornS, 'combo-ultrap-hd6000', 'combo-ultra-hd2000'];
      } else if (S.vehicle === 'moto') {
        if (S.two === 'multi') handles = [P.mtPro, P.mtMini, P.mtV6p];
        else if (S.two === 'single' && S.three) {
          // 单车型只放该品牌专用款;无专用款的品牌才回退多品牌
          const dedicated = S.three !== 'Other brand' && MT_V6[S.three] ? [MT_V6[S.three]] : [];
          handles = dedicated.length ? dedicated : [P.mtPro, P.mtMini, P.mtV6p];
        }
      } else if (S.vehicle === 'car') {
        if (S.two === 'multi') {
          if (S.three === 'pro') handles = [P.ultraP, P.eagleP, P.unicornS, P.unicorn, P.ultra, P.eagle, P.legend];
          // 半专业:CR Max 系列 + CR Pro 系列 + CR Elite P(2026-07 全店调研后分级)
          else if (S.three === 'semi') handles = [P.maxP, P.maxBTe, P.maxBT, P.max, P.proS, P.proPlus, P.eliteP];
          // 入门:低客单价 i 系列 / E660(对齐法国站分法;缺货款自动显示 Sold out)
          else if (S.three === 'essential') handles = [P.i800, P.i820, P.e660, P.i620, P.i610];
        } else if (S.two === 'single' && S.three) {
          if (EXTENDED_SET.has(S.three)) {
            handles = [P.legend]; // 扩展品牌仅 CR Legend 支持
          } else {
            // 单车型只放该品牌专用系列;无专用系列的品牌才回退多品牌
            const lad = SINGLE_BRAND[S.three] || [];
            handles = lad.length
              ? lad
              : [P.maxP, P.maxBTe, P.maxBT, P.max, P.proS, P.proPlus];
          }
        }
      }
      // 去重 + 只保留当前市场已发布的产品(套装以主机在售为准)
      const seen = new Set();
      return handles.filter((h) => {
        if (seen.has(h)) return false;
        const combo = COMBOS[h];
        if (combo ? !this.products[combo.main] : !this.products[h]) return false;
        seen.add(h);
        return true;
      });
    }

    // 套装卡数据:合计价(套件未上架时按主机价)、多变体加购
    comboData(key) {
      const c = COMBOS[key];
      const main = this.products[c.main];
      const kit = this.products[c.kit];
      const cents = main.cents + (kit ? kit.cents : 0);
      const cmpCents = (main.compareCents || main.cents) + (kit ? (kit.compareCents || kit.cents) : 0);
      const price = moneyLike(main.price, cents);
      const compare = cmpCents > cents ? moneyLike(main.price, cmpCents) : null;
      const variants = [main.variant].concat(kit ? [kit.variant] : []).join(',');
      return {
        name: c.name,
        tag: c.tag + (kit ? '' : ' · kit sold separately'),
        url: main.url,
        image: main.image,
        title: c.name,
        price, compare, variants,
        available: main.available && (!kit || kit.available)
      };
    }

    /* ---------- 渲染 ---------- */
    renderStep(n) {
      const stepEl = this.querySelector(`[data-ictf-step="${n}"]`);
      const cfg = this.stepConfig(n);
      const S = this.state;
      // 显示条件:上一步已选
      const visible = n === 1 || (cfg && (n === 2 ? !!S.vehicle : !!S.two));
      stepEl.hidden = !visible;
      if (!visible || !cfg) return;

      const titleEl = stepEl.querySelector(`[data-ictf-step-label="${n}"]`);
      if (titleEl && cfg.title) titleEl.textContent = cfg.title;

      const cur = S[cfg.key];
      const curOpt = cfg.opts.find((o) => o.key === cur);
      const icoSvg = (o) => (o && o.ico ? `<svg class="ictf__opt-ico" viewBox="0 0 24 24" aria-hidden="true">${o.ico}</svg>` : '');

      // STEP 01(仅 PC 显示):直观按钮组,点击后自动展开下一步;移动端走下方通用下拉
      if (n === 1) {
        const wrap = stepEl.querySelector('[data-ictf-chips]');
        if (wrap) {
          wrap.innerHTML = cfg.opts.map((o) =>
            `<button type="button" class="ictf__chip ictf__chip--ico" data-ictf-opt="${o.key}" aria-pressed="${o.key === cur ? 'true' : 'false'}">${icoSvg(o)}${o.label}</button>`
          ).join('');
          wrap.querySelectorAll('[data-ictf-opt]').forEach((btn) => {
            btn.addEventListener('click', () => {
              const v = btn.dataset.ictfOpt;
              this.setState({ vehicle: v, two: null, three: null, open: v === 'marine' ? null : 2 });
            });
          });
        }
        // 不 return:继续渲染移动端的下拉控件(与按钮共用同一状态)
      }

      const labelEl = stepEl.querySelector(`[data-ictf-label="${n}"]`);
      labelEl.innerHTML = curOpt ? icoSvg(curOpt) + curOpt.label : cfg.ph;
      labelEl.classList.toggle('is-placeholder', !curOpt);
      // 状态类:已完成打勾、展开时箭头旋转;展开的卡整体抬高层级(防止后续步骤文字盖住下拉)
      stepEl.classList.toggle('is-done', !!curOpt);
      stepEl.classList.toggle('is-open-step', S.open === n);
      const selBtn = stepEl.querySelector(`[data-ictf-toggle="${n}"]`);
      if (selBtn) selBtn.classList.toggle('is-open', S.open === n);

      const dd = stepEl.querySelector(`[data-ictf-dropdown="${n}"]`);
      dd.hidden = S.open !== n;
      dd.innerHTML = (cfg.search
        ? '<div class="ictf__search-wrap"><input type="text" class="ictf__search" placeholder="Type to search brand…" aria-label="Search brand"></div>'
        : '') + cfg.opts.map((o) =>
          `<button type="button" class="ictf__option${o.key === cur ? ' is-active' : ''}" data-ictf-opt="${o.key.replace(/"/g, '&quot;')}">${icoSvg(o)}${o.label}</button>`
        ).join('');
      dd.querySelectorAll('[data-ictf-opt]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const patch = { open: null };
          const val = btn.dataset.ictfOpt;
          patch[cfg.key] = val;
          if (cfg.key === 'vehicle') {
            // (移动端下拉选车型)重置后续步骤并自动展开下一步
            patch.two = null; patch.three = null;
            patch.open = val === 'marine' ? null : 2;
          }
          if (cfg.key === 'two') {
            // 改第二步 → 重置第三步;若还有第三步则自动展开
            patch.three = null;
            const v = this.state.vehicle;
            if (v === 'car' || (v === 'moto' && val === 'single')) patch.open = 3;
          }
          this.setState(patch);
        });
      });
      const search = dd.querySelector('.ictf__search');
      if (search) {
        search.addEventListener('input', () => {
          const q = search.value.trim().toLowerCase();
          dd.querySelectorAll('[data-ictf-opt]').forEach((b) => {
            b.style.display = !q || b.dataset.ictfOpt.toLowerCase().includes(q) ? '' : 'none';
          });
        });
        if (S.open === n) setTimeout(() => search.focus(), 0);
      }
    }

    render() {
      [1, 2, 3].forEach((n) => this.renderStep(n));

      const resultsEl = this.querySelector('[data-ictf-results]');
      const complete = this.isComplete();
      resultsEl.hidden = !complete;
      if (!complete) return;

      const matches = this.getMatches();
      this.querySelector('[data-ictf-count]').textContent =
        `${matches.length} ${matches.length === 1 ? this.strings.fitOne : this.strings.fitMany}`;
      const grid = this.querySelector('[data-ictf-grid]');
      grid.innerHTML = matches.map((handle, i) => {
        const combo = COMBOS[handle];
        const p = combo ? this.comboData(handle) : this.products[handle];
        const best = i === 0;
        const name = combo ? p.name : shortName(p.title);
        const tag = combo ? p.tag : (TAGS[handle] || p.title);
        const priceHtml = p.compare && p.compare !== p.price
          ? `<s style="opacity:.65;margin-right:6px">${p.compare}</s>${p.price}`
          : p.price;
        const addAttr = combo ? p.variants : this.products[handle].variant;
        const cta = p.available
          ? `<button type="button" class="ictf__buy" data-ictf-add="${addAttr}" data-ictf-url="${p.url}">${this.strings.buy} — ${p.price}</button>`
          : `<div class="ictf__sold-out">${this.strings.soldOut}</div>`;
        return `
          <div class="ictf__card${best ? ' is-best' : ''}">
            <div class="ictf__card-top">
              <span class="ictf__badge">${best ? this.strings.best : this.strings.also}</span>
              <span class="ictf__price">${priceHtml}</span>
            </div>
            <a class="ictf__card-body" href="${p.url}">
              ${p.image ? `<img class="ictf__img" src="${p.image}" alt="${String(p.title).replace(/"/g, '&quot;')}" loading="lazy" width="150" height="150">` : ''}
              <div class="ictf__card-info">
                <div class="ictf__name">${name}</div>
                <div class="ictf__tag">${tag}</div>
              </div>
            </a>
            ${cta}
          </div>`;
      }).join('');
      grid.querySelectorAll('[data-ictf-add]').forEach((btn) => {
        btn.addEventListener('click', () => this.addToCart(btn));
      });
    }

    /* ---------- 真实加购(支持套装多件;复用主题 cart 流程) ---------- */
    async addToCart(btn) {
      btn.classList.add('is-loading');
      const ids = btn.dataset.ictfAdd.split(',').filter(Boolean);
      const cartDrawer = document.querySelector('cart-drawer');
      let sections = 'cart-icon-bubble';
      if (cartDrawer) {
        const drawerSection = cartDrawer.closest('.shopify-section');
        if (drawerSection) sections += `,${drawerSection.id.replace('shopify-section-', '')}`;
      }
      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: ids.map((id) => ({ id: Number(id), quantity: 1 })),
            sections,
            sections_url: window.location.pathname
          })
        });
        const responseText = await response.text();
        let data;
        try {
          data = JSON.parse(responseText);
        } catch {
          throw new Error('Unable to add this item to the cart.');
        }
        if (!response.ok || data.status) throw new Error(data.description || data.message || response.status);
        // 加入购物车成功后跳转购物车页
        window.location.href = (window.theme && theme.routes && theme.routes.cart) || '/cart';
      } catch (error) {
        // 加购失败(如超卖):跳转产品页兜底
        window.location.href = btn.dataset.ictfUrl;
       }
    }
  }

  customElements.define('icarsoft-tool-finder', ICarsoftToolFinder);
})();
